var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPlanRoute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8a1 1 0 1 0-2 0v1a1 1 0 1 0 2 0V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 12a1 1 0 0 1 1 1v1.17a3.001 3.001 0 1 1-2 0V13a1 1 0 0 1 1-1Zm0 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h5v4H6v3H4V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5a4.5 4.5 0 1 1-9 0V14a1 1 0 1 1 2 0v1.5a2.5 2.5 0 0 0 5 0V13a1 1 0 1 1 2 0v2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPlanRoute);
export default __webpack_public_path__ + "static/media/ic_action_plan_route.710f850b66372259129efe83d4e341da.svg";
export { ForwardRef as ReactComponent };